// extracted by mini-css-extract-plugin
export var messageSideLeft = "_od-1";
export var stateContainer = "_od-0";